import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from './types';
import { UserBalance } from '../interface/users';
import { UserAPI } from '../apis/users/index';
import { userPolling } from './userSlice';

const initialState = {} as UserBalance;

export const fetchBalance = createAsyncThunk('balance/fetchBalance', async (_, { getState, dispatch }) => {
  const { user } = getState() as RootState;
  const balance = await UserAPI.getBalance(user.SsToken);
  return balance;
});

export const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalance.fulfilled, (state, action) => {
        Object.assign(state, action.payload);
      })
      .addCase(userPolling.fulfilled, (state, action) => {
        if (action.payload) Object.assign(state, action.payload.Balance.Data);
      });
  },
});

export default balanceSlice.reducer;
